<template>
    <div v-if="show">
        <div class="dd-l-container__content dd-l-container--home__container dd-l-container--has-top"
             id="dd-container-home">

            <!-- <banner-video-home></banner-video-home> -->

            <div class="dd-l-container__wrapper dd-l-container__wrapper--grid-tb">
                <banner-list-default :title="getTranslateString('How do you feel today?')" per-page="4"></banner-list-default>
            </div>
            

            <!--  <list-products-specials per-page="12"></list-products-specials> -->
            <!-- <form id="searchform2" autocomplete="off" class="dd-m-form dd-m-search">
                <div class="dd-m-form__icon-input dd-m-form__icon-input--dark">
                    <div class="v-autocomplete">
                        <div class="v-autocomplete-input-group">
                            <input type="search" placeholder="What are you looking for?" class="dd-search-value dd-m-search__input">
                        </div>
                    </div>
                    <button type="button" class="dd-m-button dd-m-button--dark dd-m-button--tiny dd-m-helper--centralize">
                        <i class="dd-m-icon icon-search"></i>
                    </button>
                </div>
            </form> -->

            <banner-wide-home-offline></banner-wide-home-offline>

            <banner-list-lites
                bgColor="#f9f9f9"
                banner-id="5"
                :reverse="false" 
                :title="getTranslateString('Fragrances for every need and occasion')"
                :description="getTranslateString('Whether you need a fragrance for a particular event or you need one to compliment your lifestyle, you will find the ideal AVON fragrance in our bespoke categories.')"></banner-list-lites>

            <banner-list-lites
                banner-id="6"
                :reverse="true" 
                :title="getTranslateString('Discover the aromas of our fragrances')"
                :description="getTranslateString('We’ve classified each of our fragrances into distinctive aroma families. Click the arrows to cycle through our aroma selection to help you make your decision.')"></banner-list-lites>    

            <!-- <banner-list-ingredients per-page="100"></banner-list-ingredients> -->
            <banner-ways-to-search
                :title="getTranslateString('Other ways to search...')"
            />
        </div>
    </div>
</template>

<script>
    import BannerListDefault from "../../banners/banner-list-default";
    import ListProductsSpecials from "../../products/list-products-specials";
    import BannerVideoHome from "../../banners/banner-video-home";
    import BannerWideHomeOffline from "../../banners/banner-wide-home-offline";
    import BannerListLites from "../../banners/banner-list-lites";
    import BannerListIngredients from "../../banners/banner-list-ingredients";
    import BannerWideHome from "../../banners/banner-wide-home";
    import BannerWaysToSearch from "../../banners/banner-ways-to-search";
    //import OptIn from "../../opt-in/opt-in";

    export default {
        components: {
            //OptIn,
            BannerListIngredients,
            BannerListLites, BannerWideHomeOffline, BannerVideoHome, ListProductsSpecials, BannerListDefault, BannerWideHome, BannerWaysToSearch, },
        data: () => {
            return {
                show: true
            }
        },
        mounted() {
        
            this.subscribe();
        },
        methods: {
            subscribe() {
                PubSub.subscribe('statusChanged', (msg, isOnline) => this.show = isOnline);
            }
        }
    }
</script>



// WEBPACK FOOTER //
// resources/site/js/components/pages/home/index.vue